<template>
  <div>
    <pickup-locations></pickup-locations>
  </div>
</template>

<script>

import PickupLocations from "components/pickup-locations/list.vue"

export default {
    name: "Checkout",
    components: {
        PickupLocations
    }
}

</script>



// WEBPACK FOOTER //
// App.vue?7ae2e7fe